import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'; // Don't forget to import PropTypes
import UserServices from '../../services/UserServices';
import StateServices from '../../services/StateServices.js';

const LAND_DEPARTMENTS = [
  'Department of Expenditure (DoE)',
  'Department of Fertilizers (DoFz)',
  'Department of Financial Services (DoFS)',
  'Department for Promotion of Industry and Internal Trade (DPIIT)',
  'Department of Administrative Reforms and Public Grievances (DARPG)',
  'Department of Agricultural Research and Education (DARE)',
  'Department of Agriculture and Farmers Welfare (DoAFW)',
  'Department of Animal Husbandry and Dairying (DoAHD)',
  'Department of Biotechnology (DBT)',
  'Department of Border Management (DoBM)',
  'Department of Chemicals and Petro-Chemicals (DoCP)',
  'Department of Commerce (DoC)',
  'Department of Consumer Affairs (DoCA)',
  'Department of Defence (DoD)',
  'Department of Defence Production (DDP)',
  'Department of Defence Research and Development (DRDO)',
  'Department of Drinking Water and Sanitation (DDWS)',
  'Department of Economic Affairs (DEA)',
  'Department of Empowerment of Persons with Disabilities (DEPWD)',
  'Department of Ex-Servicemen Welfare (DESW)',
  'Department of Fisheries (DoF)',
  'Department of Food and Public Distribution (DFPD)',
  'Department of Health Research (DHR)',
  'Department of Health and Family Welfare (DoHFW)',
  'Department of Higher Education (DoHE)',
  'Department of Home (DoH)',
  'Department of Investment and Public Asset Management (DIPAM)',
  'Department of Justice (DoJ)',
  'Department of Land Resources (DLR)',
  'Department of Legal Affairs (DoLA)',
  'Department of Military Affairs (DMA)',
  'Department of Official Language (DoOL)',
  'Department of Pension & Pensioners Welfare (DoPPW)',
  'Department of Personnel and Training (DoPT)',
  'Department of Pharmaceuticals (DoPs)',
  'Department of Science and Technology (DST)',
  'Department of Scientific and Industrial Research (DSIR)',
  'Department of Social Justice and Empowerment (DoSJE)',
  'Department of Sports (DoS)',
  'Department of Telecommunications (DoT)',
  'Department of Water Resources, River Development and Ganga Rejuvenation (DoWRGR)',
  'Department of Youth Affairs (DoYA)',
  'Legislative Department (LD)',
  'Department of Posts (DoP)',
  'Department of Public Enterprises (DPE)',
  'Department of Revenue (DoR)',
  'Department of Rural Development (DoRD)',
  'Department of School Education and Literacy (DSEL)',
  'Department of Forest(DOF)'
];

function ProfileUpdate({ selectedData, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        name: '',
        age: '',
        fathersName: '',
        mobileNo: '',
        aadharNo: '',
        presentAddress: {
            mohalla: '',
            ward: '',
            village: '',
            policeStation: '',
            district: '',
            state: '',
            pinCode: '',
        },
        permanentAddress: {
            mohalla: '',
            ward: '',

            policeStation: '',
            district: '',
            state: '',
            pinCode: '',
        },
        familyMembers: [
            {
                name: '',
                age: '',
                relation: '',
                mobileNo: '',
                aadhar: '',
                memberSalary: '',
                outside_of_uk: '',
                occupation: '',
            }
        ],
        idType: '',
        gender: '',
        image: '',
        // Property related fields
        selfOccupiedProperty: '',
        registeredHouse: '',
        areaOfHouse: '',
        landBelongsToDepartment: '',
        stayingFrom: '',
        landlordName: '',
        landlordAddress: '',
        landlordMobileNo: '',
        // Income related fields
        monthlySalary: '',
        otherSourceOfIncome: '',
        outsideUttarakhandSalary: '',
        // Bill and Water fields
        billConnectionName: '',
        billCode: '',
        billVerified: '',
        billInfo: null,
        waterConnectionName: '',
        waterCode: '',
        waterVerified: '',
        waterInfo: null,
        // Home Stay fields
        homeStayInfo: null,
        homeStayVerified: '',
        // Government Schemes
        govtSchemes: [],
        suspiciousProfile: 'No',
    });

    const [states, setStates] = useState([]);
    // Keep separate lists for present vs permanent address dropdowns
    const [presentDistricts, setPresentDistricts] = useState([]);
    const [presentPoliceStations, setPresentPoliceStations] = useState([]);
    const [permanentDistricts, setPermanentDistricts] = useState([]);
    const [permanentPoliceStations, setPermanentPoliceStations] = useState([]);
    const [occupations, setOccupations] = useState([]);
    const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');
    const [verifyingElectric, setVerifyingElectric] = useState(false);
    const [verifyingWater, setVerifyingWater] = useState(false);

    // Helper function to extract ID from object or string
    const extractId = (value) => {
        if (!value) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object' && value._id) return value._id;
        return '';
    };

    // Fetch states on component mount
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const response = await UserServices.getState();
                setStates(response.data);
            } catch (error) {
                console.error('Failed to fetch states', error);
            }
        };
        fetchStates();
    }, []);

    // Fetch occupations on component mount (Occupation table)
    useEffect(() => {
        const fetchOccupations = async () => {
            try {
                const response = await UserServices.getOccupations();
                setOccupations(response.data || []);
            } catch (error) {
                console.error('Failed to fetch occupations', error);
                setOccupations([]);
            }
        };
        fetchOccupations();
    }, []);

    // Fetch PRESENT districts based on selected present state
    useEffect(() => {
        const fetchDistricts = async () => {
            if (formValues.presentAddress.state) {
                try {
                    const response = await UserServices.getDistrictByState(formValues.presentAddress.state);
                    setPresentDistricts(response.data);
                } catch (error) {
                    console.error('Failed to fetch districts', error);
                }
            } else {
                setPresentDistricts([]);
            }
        };
        fetchDistricts();
    }, [formValues.presentAddress.state]);

    // Fetch PRESENT police stations based on selected present district
    useEffect(() => {
        const fetchThanas = async () => {
            if (formValues.presentAddress.district) {
                try {
                    const response = await UserServices.getThanaByDistrict(formValues.presentAddress.district);
                    setPresentPoliceStations(response.data);
                } catch (error) {
                    console.error('Failed to fetch police stations', error);
                }
            } else {
                setPresentPoliceStations([]);
            }
        };
        fetchThanas();
    }, [formValues.presentAddress.district]);

    // Fetch PERMANENT districts based on selected permanent state
    useEffect(() => {
        const fetchPermanentDistricts = async () => {
            if (formValues.permanentAddress.state) {
                try {
                    const response = await UserServices.getDistrictByState(formValues.permanentAddress.state);
                    setPermanentDistricts(response.data);
                } catch (error) {
                    console.error('Failed to fetch permanent districts', error);
                }
            } else {
                setPermanentDistricts([]);
            }
        };
        fetchPermanentDistricts();
    }, [formValues.permanentAddress.state]);

    // Fetch PERMANENT police stations based on selected permanent district
    useEffect(() => {
        const fetchPermanentThanas = async () => {
            if (formValues.permanentAddress.district) {
                try {
                    const response = await UserServices.getThanaByDistrict(formValues.permanentAddress.district);
                    setPermanentPoliceStations(response.data);
                } catch (error) {
                    console.error('Failed to fetch permanent police stations', error);
                }
            } else {
                setPermanentPoliceStations([]);
            }
        };
        fetchPermanentThanas();
    }, [formValues.permanentAddress.district]);

    // Set form values when selectedData is available
    useEffect(() => {
        if (selectedData) {
            const presentStateId = extractId(selectedData.presentAddress?.state);
            const presentDistrictId = extractId(selectedData.presentAddress?.district);
            const presentPoliceStationId = extractId(selectedData.presentAddress?.policeStation);
            const permanentStateId = extractId(selectedData.permanentAddress?.state);
            const permanentDistrictId = extractId(selectedData.permanentAddress?.district);
            const permanentPoliceStationId = extractId(selectedData.permanentAddress?.policeStation);

            setFormValues({
                name: selectedData.name || '',
                age: selectedData.age || '',
                fathersName: selectedData.fathersName || '',
                mobileNo: selectedData.mobileNo || '',
                aadharNo: selectedData.aadharNo || '',
                presentAddress: {
                    mohalla: selectedData.presentAddress?.mohalla || '',
                    ward: selectedData.presentAddress?.ward || '',
                    village: selectedData.presentAddress?.village || '',
                    policeStation: presentPoliceStationId,
                    district: presentDistrictId,
                    state: presentStateId,
                    pinCode: selectedData.presentAddress?.pinCode || '',
                },
                permanentAddress: {
                    mohalla: selectedData.permanentAddress?.mohalla || '',
                    ward: selectedData.permanentAddress?.ward || '',
                    policeStation: permanentPoliceStationId,
                    district: permanentDistrictId,
                    state: permanentStateId,
                    pinCode: selectedData.permanentAddress?.pinCode || '',
                },
                familyMembers: selectedData.familyMembers && selectedData.familyMembers.length ? selectedData.familyMembers : [{
                    name: '',
                    age: '',
                    relation: '',
                    mobileNo: '',
                    aadhar: '',
                    memberSalary: '',
                    outside_of_uk: '',
                    occupation: '',
                }],
                idType: selectedData.idType || '',
                gender: selectedData.gender || '',
                image: selectedData.image || null,
                // Property related fields
                selfOccupiedProperty: selectedData.selfOccupiedProperty || '',
                registeredHouse: selectedData.registeredHouse || '',
                areaOfHouse: selectedData.areaOfHouse || '',
                landBelongsToDepartment: selectedData.landBelongsToDepartment || '',
                stayingFrom: selectedData.stayingFrom || '',
                landlordName: selectedData.landlordName || '',
                landlordAddress: selectedData.landlordAddress || '',
                landlordMobileNo: selectedData.landlordMobileNo || '',
                // Income related fields
                monthlySalary: selectedData.monthlySalary || '',
                otherSourceOfIncome: selectedData.otherSourceOfIncome || '',
                outsideUttarakhandSalary: selectedData.outsideUttarakhandSalary || '',
                // Bill and Water fields
                billConnectionName: selectedData.billConnectionName || '',
                billCode: selectedData.billCode || '',
                billVerified: selectedData.billVerified || '',
                billInfo: selectedData.billInfo || null,
                waterConnectionName: selectedData.waterConnectionName || '',
                waterCode: selectedData.waterCode || '',
                waterVerified: selectedData.waterVerified || '',
                waterInfo: selectedData.waterInfo || null,
                // Home Stay fields
                homeStayInfo: selectedData.homeStayInfo || null,
                homeStayVerified: selectedData.homeStayVerified || '',
                // Government Schemes
                govtSchemes: selectedData.govtSchemes && selectedData.govtSchemes.length > 0
                    ? selectedData.govtSchemes.map(scheme => ({
                        schemeName: scheme.schemeName || '',
                        schemeNo: scheme.schemeNo || '',
                        schemeInfo: scheme.schemeInfo || null,
                        schemeVerified: scheme.schemeVerified || '',
                        schemeDocument: scheme.schemeDocument || ''
                    }))
                    : [],
                suspiciousProfile:
                    selectedData.suspiciousProfile === 'Yes' || selectedData.suspiciousProfile === 'No'
                        ? selectedData.suspiciousProfile
                        : 'No',
            });
            if (selectedData.image) {
                setPreviewImage(process.env.REACT_APP_URL + selectedData.image);
            }

            // Preload dropdown options for present/permanent when editing
            if (presentStateId) {
                UserServices.getDistrictByState(presentStateId).then((response) => {
                    setPresentDistricts(response.data);
                }).catch((error) => console.error('Failed to fetch present districts', error));
            }
            if (presentDistrictId) {
                UserServices.getThanaByDistrict(presentDistrictId).then((response) => {
                    setPresentPoliceStations(response.data);
                }).catch((error) => console.error('Failed to fetch present police stations', error));
            }
            if (permanentStateId) {
                UserServices.getDistrictByState(permanentStateId).then((response) => {
                    setPermanentDistricts(response.data);
                }).catch((error) => console.error('Failed to fetch permanent districts', error));
            }
            if (permanentDistrictId) {
                UserServices.getThanaByDistrict(permanentDistrictId).then((response) => {
                    setPermanentPoliceStations(response.data);
                }).catch((error) => console.error('Failed to fetch permanent police stations', error));
            }
        }
    }, [selectedData]);

    // Handle input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const [parentKey, childKey] = name.split('.');

        if (childKey) {
            // Handle dependent dropdown resets
            if (parentKey === 'presentAddress' && childKey === 'state') {
                setPresentDistricts([]);
                setPresentPoliceStations([]);
                setFormValues((prevValues) => ({
                    ...prevValues,
                    presentAddress: {
                        ...prevValues.presentAddress,
                        state: value,
                        district: '',
                        policeStation: '',
                    },
                }));
                return;
            }
            if (parentKey === 'presentAddress' && childKey === 'district') {
                setPresentPoliceStations([]);
                setFormValues((prevValues) => ({
                    ...prevValues,
                    presentAddress: {
                        ...prevValues.presentAddress,
                        district: value,
                        policeStation: '',
                    },
                }));
                return;
            }
            if (parentKey === 'permanentAddress' && childKey === 'state') {
                setPermanentDistricts([]);
                setPermanentPoliceStations([]);
                setFormValues((prevValues) => ({
                    ...prevValues,
                    permanentAddress: {
                        ...prevValues.permanentAddress,
                        state: value,
                        district: '',
                        policeStation: '',
                    },
                }));
                return;
            }
            if (parentKey === 'permanentAddress' && childKey === 'district') {
                setPermanentPoliceStations([]);
                setFormValues((prevValues) => ({
                    ...prevValues,
                    permanentAddress: {
                        ...prevValues.permanentAddress,
                        district: value,
                        policeStation: '',
                    },
                }));
                return;
            }

            // Default nested update
            setFormValues((prevValues) => ({
                ...prevValues,
                [parentKey]: {
                    ...prevValues[parentKey],
                    [childKey]: value,
                },
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: value,
            }));
        }
    };

    // Handle image change
    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     setFormValues({ ...formValues, image: file });

    //     // Preview the uploaded image
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //         setPreviewImage(reader.result);
    //     };
    //     if (file) {
    //         reader.readAsDataURL(file);
    //     }
    // };
    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const allowedTypes = ['image/jpeg', 'image/jpg'];
            if (!allowedTypes.includes(file.type)) {
                alert('Only JPEG and JPG files are allowed!');
                event.target.value = ''; // Reset the input value to clear the invalid file
                return;
            }

            // Update form state only if the file type is valid
            setFormValues({ ...formValues, image: file });

            // Preview the uploaded image
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    // Handle family member changes
    const handleFamilyMemberChange = (index, event) => {
        const { name, value } = event.target;
        const updatedFamilyMembers = [...formValues.familyMembers];
        updatedFamilyMembers[index] = { ...updatedFamilyMembers[index], [name]: value };
        setFormValues({ ...formValues, familyMembers: updatedFamilyMembers });
    };

    // Add a new family member
    const handleAddFamilyMember = () => {
        setFormValues({
            ...formValues,
            familyMembers: [...formValues.familyMembers, { name: '', age: '', relation: '', mobileNo: '', aadhar: '', memberSalary: '', outside_of_uk: '', occupation: '' }],
        });
    };

    // Remove a family member
    const handleRemoveFamilyMember = (index) => {
        const updatedFamilyMembers = formValues.familyMembers.filter((_, i) => i !== index);
        setFormValues({ ...formValues, familyMembers: updatedFamilyMembers });
    };

    // Handle electricity bill verification
    const handleVerifyElectricBill = async () => {
        if (!formValues.billCode) {
            alert('Please enter Bill Code/Account Number first');
            return;
        }
        setVerifyingElectric(true);
        try {
            const response = await UserServices.verifyElectricBill({ accountNumber: formValues.billCode });
            if (response.success && response.data) {
                const hasValidData = response.data && (
                    (response.data.consumerName || response.data.accountNumber || response.data.consumerDetails) ||
                    (!response.encrypted && Object.keys(response.data).length > 0)
                );
                setFormValues({
                    ...formValues,
                    billVerified: hasValidData ? 'Valid' : 'Invalid',
                    billInfo: response.data || {}
                });
                alert(hasValidData ? 'Electricity bill verified successfully!' : 'Electricity bill verification failed - No valid data found');
            } else {
                setFormValues({ ...formValues, billVerified: 'Invalid' });
                alert('Electricity bill verification failed');
            }
        } catch (error) {
            console.error('Error verifying electricity bill:', error);
            const errorMessage = error.response?.data?.error || error.message || 'Unknown error';
            setFormValues({ ...formValues, billVerified: 'Invalid' });
            alert(`Error verifying electricity bill: ${errorMessage}`);
        } finally {
            setVerifyingElectric(false);
        }
    };

    // Handle water bill verification
    const handleVerifyWaterBill = async () => {
        if (!formValues.waterCode) {
            alert('Please enter Water Code/Consumer Code first');
            return;
        }
        setVerifyingWater(true);
        try {
            const response = await UserServices.verifyWaterBill({ consCode: formValues.waterCode });
            if (response.success && response.data) {
                const hasValidData = response.data && (
                    response.data.consumerName ||
                    response.data.consumerCode ||
                    response.data.consumerDetails ||
                    (typeof response.data === 'object' && Object.keys(response.data).length > 0)
                );
                setFormValues({
                    ...formValues,
                    waterVerified: hasValidData ? 'Valid' : 'Invalid',
                    waterInfo: response.data || {}
                });
                alert(hasValidData ? 'Water bill verified successfully!' : 'Water bill verification failed - No valid data found');
            } else {
                setFormValues({ ...formValues, waterVerified: 'Invalid' });
                alert('Water bill verification failed');
            }
        } catch (error) {
            console.error('Error verifying water bill:', error);
            const errorMessage = error.response?.data?.error || error.message || 'Unknown error';
            setFormValues({ ...formValues, waterVerified: 'Invalid' });
            alert(`Error verifying water bill: ${errorMessage}`);
        } finally {
            setVerifyingWater(false);
        }
    };

    const sanitizeFamilyMembers = (members) =>
        (members || []).map((m) => {
            const out = { ...m };
            if (out.outside_of_uk !== 'Yes' && out.outside_of_uk !== 'No') {
                delete out.outside_of_uk;
            }
            return out;
        });

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Prepare form data
        const formData = new FormData();
        formData.append('name', formValues.name);
        formData.append('age', formValues.age);
        formData.append('fathersName', formValues.fathersName);
        formData.append('mobileNo', formValues.mobileNo);
        formData.append('aadharNo', formValues.aadharNo);
        formData.append('presentAddress', JSON.stringify(formValues.presentAddress));
        formData.append('permanentAddress', JSON.stringify(formValues.permanentAddress));
        formData.append('familyMembers', JSON.stringify(sanitizeFamilyMembers(formValues.familyMembers)));
        formData.append('idType', formValues.idType);
        formData.append('gender', formValues.gender);
        if (formValues.selfOccupiedProperty === 'Yes' || formValues.selfOccupiedProperty === 'No') {
            formData.append('selfOccupiedProperty', formValues.selfOccupiedProperty);
        }
        if (formValues.registeredHouse === 'Yes' || formValues.registeredHouse === 'No') {
            formData.append('registeredHouse', formValues.registeredHouse);
        }
        formData.append('areaOfHouse', formValues.areaOfHouse);
        if (formValues.landBelongsToDepartment) {
            formData.append('landBelongsToDepartment', formValues.landBelongsToDepartment);
        }
        formData.append('stayingFrom', formValues.stayingFrom);
        formData.append('landlordName', formValues.landlordName);
        formData.append('landlordAddress', formValues.landlordAddress);
        formData.append('landlordMobileNo', formValues.landlordMobileNo);
        // Income related fields
        formData.append('monthlySalary', formValues.monthlySalary);
        formData.append('otherSourceOfIncome', formValues.otherSourceOfIncome);
        formData.append('outsideUttarakhandSalary', formValues.outsideUttarakhandSalary);
        // Bill and Water fields
        formData.append('billConnectionName', formValues.billConnectionName);
        formData.append('billCode', formValues.billCode);
        formData.append('billVerified', formValues.billVerified);
        if (formValues.billInfo) {
            formData.append('billInfo', JSON.stringify(formValues.billInfo));
        }
        formData.append('waterConnectionName', formValues.waterConnectionName);
        formData.append('waterCode', formValues.waterCode);
        formData.append('waterVerified', formValues.waterVerified);
        if (formValues.waterInfo) {
            formData.append('waterInfo', JSON.stringify(formValues.waterInfo));
        }
        // Home Stay fields
        formData.append('homeStayVerified', formValues.homeStayVerified);
        if (formValues.homeStayInfo) {
            formData.append('homeStayInfo', JSON.stringify(formValues.homeStayInfo));
        }
        formData.append(
            'suspiciousProfile',
            formValues.suspiciousProfile === 'Yes' || formValues.suspiciousProfile === 'No'
                ? formValues.suspiciousProfile
                : 'No'
        );
        // Government Schemes
        formData.append('govtSchemes', JSON.stringify(formValues.govtSchemes));
        if (formValues.image) {
            formData.append('image', formValues.image);
        }

        try {
            const res = await UserServices.updateUser(selectedData._id, formData);
            if (res.status === true) {
                alert('Profile updated successfully');
                onSuccess();
                closeModal();
            } else {
                // alert('Something went wrong');
                alert(res.message || 'Something went wrong');
            }
        } catch (error) {
            console.error('Failed to update profile', error);

            // Check if the error response has a message from the backend
            const errorMessage = error.response?.data?.message || 'An error occurred while updating the profile.';
            alert(errorMessage); // Show backend error message

        }
    };

    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Profile </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                    <div className="row">
                                            {/* Name */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex ">
                                                    <label>Name:</label>
                                                    <input type="text" name="name" value={formValues.name} onChange={handleInputChange} className="form-control" required />
                                                </div>
                                            </div>

                                            {/* Age */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Age:</label>
                                                    <input type="text" name="age" value={formValues.age} onChange={handleInputChange} className="form-control" required />
                                                </div>
                                            </div>

                                            {/* Father's Name */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Father's Name:</label>
                                                    <input type="text" name="fathersName" value={formValues.fathersName} onChange={handleInputChange} className="form-control" required />
                                                </div>
                                            </div>

                                            {/* Mobile Number */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Mobile No:</label>
                                                    <input type="text" name="mobileNo" value={formValues.mobileNo} onChange={handleInputChange} className="form-control" required />
                                                </div>
                                            </div>

                                            {/* Aadhar Number */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Aadhar No:</label>
                                                    <input type="text" name="aadharNo" value={formValues.aadharNo} onChange={handleInputChange} className="form-control" required />
                                                </div>
                                            </div>
                                            {/* Gender */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Gender:</label>
                                                    <select name="gender" value={formValues.gender} onChange={handleInputChange} className="form-control" required>
                                                        <option value="">Select</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <br />
                                            <h4 style={{color:'#677788'}}><strong>Present Address:</strong></h4><br />
                                            {/* - Mohalla */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Mohalla:</label>
                                                    <input type="text" name="presentAddress.mohalla" value={formValues.presentAddress.mohalla} onChange={handleInputChange} className="form-control" required />
                                                </div>
                                            </div>

                                            {/* - Ward */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Ward:</label>
                                                    <input type="text" name="presentAddress.ward" value={formValues.presentAddress.ward} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label> Pincode:</label>
                                                    <input type="text" name="presentAddress.pinCode" value={formValues.presentAddress.pinCode} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>

                                            {/* State */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field ">
                                                    <label>State:</label>
                                                    <select
                                                        className="form-control"
                                                        name="presentAddress.state"
                                                        value={formValues.presentAddress.state}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="">--Select State--</option>
                                                        {states.map((state) => (
                                                            <option key={state._id} value={state._id}>
                                                                {state.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* State */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>District:</label>
                                                    <select
                                                        className="form-control"
                                                        name="presentAddress.district"
                                                        value={formValues.presentAddress.district}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="">--Select District--</option>
                                                        {presentDistricts.map((district) => (
                                                            <option key={district._id} value={district._id}>
                                                                {district.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Police Station:</label>
                                                    <select
                                                        className="form-control"
                                                        name="presentAddress.policeStation"
                                                        value={formValues.presentAddress.policeStation}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="">--Select policeStation--</option>
                                                        {presentPoliceStations.map((policeStation) => (
                                                            <option key={policeStation._id} value={policeStation._id}>
                                                                {policeStation.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <br />

                                            {/* Permanent Address - Mohalla */}
                                            <h4 style={{color:'#677788'}}><strong>Permanent Address:</strong></h4><br />
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label> Mohalla:</label>
                                                    <input type="text" name="permanentAddress.mohalla" value={formValues.permanentAddress.mohalla} onChange={handleInputChange} className="form-control" required />
                                                </div>
                                            </div>

                                            {/*  - Ward */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label> Ward:</label>
                                                    <input type="text" name="permanentAddress.ward" value={formValues.permanentAddress.ward} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label> Pincode:</label>
                                                    <input type="text" name="permanentAddress.pinCode" value={formValues.permanentAddress.pinCode} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                          

                                            {/* State */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>State</label>
                                                    <select
                                                        className="form-control"
                                                        name="permanentAddress.state"
                                                        value={formValues.permanentAddress.state}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="">--Select State--</option>
                                                        {states.map((state) => (
                                                            <option key={state._id} value={state._id}>
                                                                {state.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>District</label>
                                                    <select
                                                        className="form-control"
                                                        name="permanentAddress.district"
                                                        value={formValues.permanentAddress.district}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="">--Select District--</option>
                                                        {permanentDistricts.map((district) => (
                                                            <option key={district._id} value={district._id}>
                                                                {district.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Police Station</label>
                                                    <select
                                                        className="form-control"
                                                        name="permanentAddress.policeStation"
                                                        value={formValues.permanentAddress.policeStation}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="">--Select policeStation--</option>
                                                        {permanentPoliceStations.map((policeStation) => (
                                                            <option key={policeStation._id} value={policeStation._id}>
                                                                {policeStation.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* family member */}
                                            <h4 style={{color:'#677788'}}><strong>Family Members:</strong></h4><br />
                                            {formValues.familyMembers.map((member, index) => (
                                                <div key={index} className="family-member">
                                                    <div className="row">
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field">
                                                                <label>Name</label>
                                                                <input
                                                                    type="text"
                                                                    name="name"
                                                                    placeholder="Name"
                                                                    value={member.name}
                                                                    onChange={(e) => handleFamilyMemberChange(index, e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field">
                                                                <label>Age</label>
                                                                <input
                                                                    type="text"
                                                                    name="age"
                                                                    placeholder="Age"
                                                                    value={member.age}
                                                                    onChange={(e) => handleFamilyMemberChange(index, e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field">
                                                                <label>Relation</label>
                                                                <input
                                                                    type="text"
                                                                    name="relation"
                                                                    placeholder="Relation"
                                                                    value={member.relation}
                                                                    onChange={(e) => handleFamilyMemberChange(index, e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field">
                                                                <label>mobile No</label>
                                                                <input
                                                                    type="text"
                                                                    name="mobileNo"
                                                                    placeholder="Mobile No"
                                                                    value={member.mobileNo}
                                                                    onChange={(e) => handleFamilyMemberChange(index, e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field">
                                                                <label>Aadhar</label>
                                                                <input
                                                                    type="text"
                                                                    name="aadhar"
                                                                    placeholder="Aadhar No"
                                                                    value={member.aadhar}
                                                                    onChange={(e) => handleFamilyMemberChange(index, e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field">
                                                                <label>Member Salary</label>
                                                                <input
                                                                    type="text"
                                                                    name="memberSalary"
                                                                    placeholder="Member Salary"
                                                                    value={member.memberSalary}
                                                                    onChange={(e) => handleFamilyMemberChange(index, e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field">
                                                                <label>Outside of UK</label>
                                                                <select
                                                                    name="outside_of_uk"
                                                                    value={member.outside_of_uk}
                                                                    onChange={(e) => handleFamilyMemberChange(index, e)}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No">No</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field">
                                                                <label>Occupation</label>
                                                                <select
                                                                    name="occupation"
                                                                    value={member.occupation || ''}
                                                                    onChange={(e) => handleFamilyMemberChange(index, e)}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {occupations.map((occ) => (
                                                                        <option key={occ._id} value={occ.name}>
                                                                            {occ.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button type="button" className='btn btn-danger' onClick={() => handleRemoveFamilyMember(index)}>
                                                        Remove
                                                    </button>
                                                </div>
                                            ))}
                                            <div className='col-lg-12'>
                                                <button type="button" className='submit-green-btn' onClick={handleAddFamilyMember}>
                                                    Add
                                                </button>
                                            </div>

                                            <div className='clear-flex'></div>
                                            <br />
                                            <div className="col-lg-3 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Id Type:</label>
                                                    <input type="text" name="idType" value={formValues.idType} onChange={handleInputChange} className="form-control" required />
                                                </div>
                                            </div>

                                            {/* Property Details Section */}
                                            <div className='clear-flex'></div>
                                            <br />
                                            <h4 style={{color:'#677788'}}><strong>Property Details:</strong></h4><br />
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Self Occupied Property:</label>
                                                    <select name="selfOccupiedProperty" value={formValues.selfOccupiedProperty} onChange={handleInputChange} className="form-control">
                                                        <option value="">Select</option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Registered House:</label>
                                                    <select name="registeredHouse" value={formValues.registeredHouse} onChange={handleInputChange} className="form-control">
                                                        <option value="">Select</option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {formValues.registeredHouse === 'Yes' && (
                                                <div className="col-lg-4 col-md-6">
                                                    <div className="input-field d-flex">
                                                        <label>Area of House:</label>
                                                        <input type="text" name="areaOfHouse" value={formValues.areaOfHouse} onChange={handleInputChange} className="form-control" />
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Land Belongs to Department:</label>
                                                    <select name="landBelongsToDepartment" value={formValues.landBelongsToDepartment} onChange={handleInputChange} className="form-control">
                                                        <option value="">Select</option>
                                                        {LAND_DEPARTMENTS.map((dept) => (
                                                            <option key={dept} value={dept}>{dept}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Staying From (Year):</label>
                                                    <input type="text" name="stayingFrom" value={formValues.stayingFrom} onChange={handleInputChange} className="form-control" placeholder="e.g., 2020, 2021" />
                                                </div>
                                            </div>

                                            {formValues.selfOccupiedProperty === 'No' && (
                                                <>
                                                    <div className="col-lg-4 col-md-6">
                                                        <div className="input-field d-flex">
                                                            <label>Landlord Name:</label>
                                                            <input type="text" name="landlordName" value={formValues.landlordName} onChange={handleInputChange} className="form-control" />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4 col-md-6">
                                                        <div className="input-field d-flex">
                                                            <label>Landlord Address:</label>
                                                            <input type="text" name="landlordAddress" value={formValues.landlordAddress} onChange={handleInputChange} className="form-control" />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4 col-md-6">
                                                        <div className="input-field d-flex">
                                                            <label>Landlord Mobile No:</label>
                                                            <input type="text" name="landlordMobileNo" value={formValues.landlordMobileNo} onChange={handleInputChange} className="form-control" />
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            {/* Income Details Section */}
                                            <div className='clear-flex'></div>
                                            <br />
                                            <h4 style={{color:'#677788'}}><strong>Income Details:</strong></h4><br />
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Monthly Salary:</label>
                                                    <input type="text" name="monthlySalary" value={formValues.monthlySalary} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Other Source of Income:</label>
                                                    <input type="text" name="otherSourceOfIncome" value={formValues.otherSourceOfIncome} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Outside Uttarakhand Salary:</label>
                                                    <input type="text" name="outsideUttarakhandSalary" value={formValues.outsideUttarakhandSalary} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>

                                            {/* Electricity Bill Information */}
                                            <div className='clear-flex'></div>
                                            <br />
                                            <h4 style={{color:'#677788'}}><strong>Electricity Bill Information:</strong></h4><br />
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Bill Connection Name:</label>
                                                    <input type="text" name="billConnectionName" value={formValues.billConnectionName} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Bill Code/Account Number:</label>
                                                    <input type="text" name="billCode" value={formValues.billCode} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Bill Verified:</label>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                        <select name="billVerified" value={formValues.billVerified || ''} onChange={handleInputChange} className="form-control" style={{ color: formValues.billVerified === 'Valid' ? 'green' : formValues.billVerified === 'Invalid' ? 'red' : 'inherit', fontWeight: 'bold' }}>
                                                            <option value="Valid">Valid</option>
                                                            <option value="Invalid">Invalid</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {selectedData?.billDocument && (
                                                <div className="col-lg-12">
                                                    <div className="input-field d-flex">
                                                        <label>Bill Document:</label>
                                                        <div style={{ marginLeft: '10px' }}>
                                                            <a href={process.env.REACT_APP_URL + selectedData.billDocument} target='_blank' rel="noopener noreferrer">
                                                                <img src={`${process.env.REACT_APP_URL}${selectedData.billDocument}`} alt="Bill Document" style={{ height: '100px', width: '100px', objectFit: 'contain' }} />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {formValues.billInfo && (
                                                <div className="col-lg-12">
                                                    <div className="input-field d-flex">
                                                        <label>Bill Information Details:</label>
                                                        <div style={{ marginLeft: '10px', flex: 1 }}>
                                                            <pre style={{ background: '#f8f9fa', padding: '10px', borderRadius: '5px', fontSize: '12px' }}>
                                                                {JSON.stringify(formValues.billInfo, null, 2)}
                                                            </pre>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className='clear-flex'></div>
                                            <br />
                                            <h4 style={{color:'#677788'}}><strong>Water Information:</strong></h4><br />
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Water Connection Name:</label>
                                                    <input type="text" name="waterConnectionName" value={formValues.waterConnectionName} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Water Code/Consumer Code:</label>
                                                    <input type="text" name="waterCode" value={formValues.waterCode} onChange={handleInputChange} className="form-control" />
                                                </div>
                                            </div>
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Water Verified:</label>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                        <select name="waterVerified" value={formValues.waterVerified || ''} onChange={handleInputChange} className="form-control" style={{ color: formValues.waterVerified === 'Valid' ? 'green' : formValues.waterVerified === 'Invalid' ? 'red' : 'inherit', fontWeight: 'bold' }}>
                                                            <option value="Valid">Valid</option>
                                                            <option value="Invalid">Invalid</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {selectedData?.waterDocument && (
                                                <div className="col-lg-12">
                                                    <div className="input-field d-flex">
                                                        <label>Water Document:</label>
                                                        <div style={{ marginLeft: '10px' }}>
                                                            <a href={process.env.REACT_APP_URL + selectedData.waterDocument} target='_blank' rel="noopener noreferrer">
                                                                <img src={`${process.env.REACT_APP_URL}${selectedData.waterDocument}`} alt="Water Document" style={{ height: '100px', width: '100px', objectFit: 'contain' }} />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {formValues.waterInfo && (
                                                <div className="col-lg-12">
                                                    <div className="input-field d-flex">
                                                        <label>Water Information Details:</label>
                                                        <div style={{ marginLeft: '10px', flex: 1 }}>
                                                            <pre style={{ background: '#f8f9fa', padding: '10px', borderRadius: '5px', fontSize: '12px' }}>
                                                                {JSON.stringify(formValues.waterInfo, null, 2)}
                                                            </pre>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className='clear-flex'></div>
                                            <br />
                                            <h4 style={{color:'#677788'}}><strong>Home Stay Information:</strong></h4><br />
                                            
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Home Stay Verified:</label>
                                                    <select name="homeStayVerified" value={formValues.homeStayVerified || ''} onChange={handleInputChange} className="form-control" style={{ color: formValues.homeStayVerified === 'Valid' ? 'green' : formValues.homeStayVerified === 'Invalid' ? 'red' : 'inherit', fontWeight: 'bold' }}>
                                                        <option value="Valid">Valid</option>
                                                        <option value="Invalid">Invalid</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {formValues.homeStayInfo && (
                                                <div className="col-lg-12">
                                                    <div className="input-field d-flex">
                                                        <label>Home Stay Information Details:</label>
                                                        <div style={{ marginLeft: '10px', flex: 1 }}>
                                                            <pre style={{ background: '#f8f9fa', padding: '10px', borderRadius: '5px', fontSize: '12px' }}>
                                                                {JSON.stringify(formValues.homeStayInfo, null, 2)}
                                                            </pre>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className='clear-flex'></div>
                                            <br />
                                            <h4 style={{color:'#677788'}}><strong>Additional flags:</strong></h4><br />
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field d-flex">
                                                    <label>Suspicious profile:</label>
                                                    <select
                                                        name="suspiciousProfile"
                                                        value={formValues.suspiciousProfile === 'Yes' || formValues.suspiciousProfile === 'No' ? formValues.suspiciousProfile : 'No'}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    >
                                                        <option value="No">No</option>
                                                        <option value="Yes">Yes</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className='clear-flex'></div>
                                            <br />
                                            <h4 style={{color:'#677788'}}><strong>Government Schemes:</strong></h4><br />
                                            
                                            {formValues.govtSchemes && formValues.govtSchemes.length > 0 ? (
                                                formValues.govtSchemes.map((scheme, index) => (
                                                    <div key={index} className="col-lg-12" style={{ marginBottom: '20px', border: '1px solid #ddd', padding: '15px', borderRadius: '5px' }}>
                                                        <h5 style={{color:'#677788'}}>Scheme {index + 1}:</h5>
                                                        
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field d-flex">
                                                                <label>Scheme Name:</label>
                                                                <input
                                                                    type="text"
                                                                    value={scheme?.schemeName ?? ''}
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const updatedSchemes = [...formValues.govtSchemes];
                                                                        updatedSchemes[index] = {
                                                                            ...updatedSchemes[index],
                                                                            schemeName: e.target.value,
                                                                        };
                                                                        setFormValues({ ...formValues, govtSchemes: updatedSchemes });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field d-flex">
                                                                <label>Scheme No:</label>
                                                                <input
                                                                    type="text"
                                                                    value={scheme?.schemeNo ?? ''}
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const updatedSchemes = [...formValues.govtSchemes];
                                                                        updatedSchemes[index] = {
                                                                            ...updatedSchemes[index],
                                                                            schemeNo: e.target.value,
                                                                        };
                                                                        setFormValues({ ...formValues, govtSchemes: updatedSchemes });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="col-lg-4 col-md-6">
                                                            <div className="input-field d-flex">
                                                                <label>Scheme Verified:</label>
                                                                <select
                                                                    value={scheme?.schemeVerified || ''}
                                                                    onChange={(e) => {
                                                                        const updatedSchemes = [...formValues.govtSchemes];
                                                                        updatedSchemes[index] = { ...updatedSchemes[index], schemeVerified: e.target.value };
                                                                        setFormValues({ ...formValues, govtSchemes: updatedSchemes });
                                                                    }}
                                                                    className="form-control"
                                                                    style={{ color: scheme?.schemeVerified === 'Valid' ? 'green' : scheme?.schemeVerified === 'Invalid' ? 'red' : 'inherit', fontWeight: 'bold' }}
                                                                >
                                                                    <option value="Valid">Valid</option>
                                                                    <option value="Invalid">Invalid</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        {scheme?.schemeInfo && (
                                                            <div className="col-lg-12">
                                                                <div className="input-field d-flex">
                                                                    <label>Scheme Information Details:</label>
                                                                    <div style={{ marginLeft: '10px', flex: 1 }}>
                                                                        <pre style={{ background: '#f8f9fa', padding: '10px', borderRadius: '5px', fontSize: '12px' }}>
                                                                            {JSON.stringify(scheme.schemeInfo, null, 2)}
                                                                        </pre>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {scheme?.schemeDocument && (
                                                            <div className="col-lg-12">
                                                                <div className="input-field d-flex">
                                                                    <label>Scheme Document:</label>
                                                                    <div style={{ marginLeft: '10px' }}>
                                                                        <a href={process.env.REACT_APP_URL + scheme.schemeDocument} target='_blank' rel="noopener noreferrer">
                                                                            <img src={`${process.env.REACT_APP_URL}${scheme.schemeDocument}`} alt="Scheme Document" style={{ height: '100px', width: '100px', objectFit: 'contain' }} />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="col-lg-12">
                                                    <div className="input-field d-flex">
                                                        <label>No Government Schemes Available</label>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Profile Picture */}
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-field">
                                                    <label>Upload<span className="red">*</span></label>
                                                    <input type="file" accept=".jpeg, .jpg" name="image" className="form-control" onChange={handleImageChange} />
                                                    <div className="file-preview text-center">
                                                        <img id="uploadFile" src={previewImage} alt="your image" />
                                                    </div>
                                                </div>
                                                {/* <div className="input-field">
                                                    <label>Profile Picture</label>
                                                    <div className="profile-img">
                                                        <img src={previewImage} alt="Preview" />
                                                        <input type="file" className="form-control" onChange={handleImageChange} />
                                                    </div>
                                                </div> */}
                                            </div>


                                            {/* Submit Button */}
                                            <div className="col-lg-12">
                                                <div>
                                                    <button type="submit" className="submit-green-btn">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

ProfileUpdate.propTypes = {
    selectedData: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

export default ProfileUpdate;
